<script>
	import * as d3 from 'd3';
    import { onMount } from 'svelte';
    import scrollama from 'scrollama';
    import { scroll } from './state';

	import LatentSpace from './LatentSpace.svelte';
    import Loader from './Loader.svelte';
    import Header from './Header.svelte';
    import Footer from './Footer.svelte';
    import SplashScreen from './SplashScreen.svelte';

	import subheaders from '../public/data/subheader_text.json';

    const dataFilePromises = [
        d3.csv("data/merged_metFaces.csv"),
        d3.csv("data/clusters.csv"),
        d3.csv("data/cluster_ranges.csv"),
        d3.csv("data/generated_Faces.csv")
    ];

    let dataLoad = Promise.all(dataFilePromises).then(data => {
        shuffleArray(data[0]);
        return data;
    })

    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
    }

	let scrollIndex = 0;
    let scrollProgress = 0;
    let scrollDirection = "down";
    const scroller = scrollama();

	onMount(() => {
        scroller
            .setup({
                step: ".step",
                offset: 1.0,
                progress: false,
                order: false
                // threshold: 4
            })
            .onStepProgress(({ element, index, progress }) => {
                scrollProgress = progress;
            })
            .onStepEnter(({ element, index, direction }) => {
                scrollIndex = index;
                scrollDirection = direction;
            })
            .onStepExit((response) => {
            });
    })

    $: scroll.update(current => {
        scroller.resize();
        return {
            index: scrollIndex,
            progress: scrollProgress,
            direction: scrollDirection
        }
    })

</script>
<svelte:window on:resize={() => { scroller.resize() } }/>
<main>

	<Header />
    {#await dataLoad}
		<div />
    {:then data}
		<SplashScreen />
    {/await}
	<section class="wrapper">
		<figure>
			{#await dataLoad}
				<Loader />
			{:then data}
                <LatentSpace metFacesData={data[0]} clusterData={data[1]} clusterRanges={data[2]} generatedData={data[3]}/>
			{/await}
		</figure>

		<article>
			{#each subheaders as { title, text, small}, i}
				<div class="step" class:phantom={i === 0 || i === (subheaders.length - 1)} key={i}>
					<div class="card">
						<p>{title}</p>
                        {#each text as {t}, i}
                        <p class="card-text">{text[i]}</p>
                        {/each}
                        <p class="card-text-small">{small || ""}</p>
					</div>
				</div>
			{/each}
		</article>
	</section>
	<section class="footer-section">
		<Footer />
	</section>
</main>

<style>

	figure {
        position: sticky;
        left: 0;
        top: 0;
        width: 100%;
        margin: 0;
    }

    article {
        position: relative;
        left: 63.5vw;
        max-width: 0;
        margin: 0 10rem 0 0;
        z-index: 10;
    }

    .step {
        margin: 0 auto 10vh auto;
        height: 100vh;
        max-width: 0;
    }

    .card {
        width: 30rem;
        padding: 1rem 1rem;
        background-color: rgba(255,255,255,0.9);
        border-radius: 2px;
        text-align: center;
        box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
        padding-bottom: 30px;
        background-image: url('https://www.dropbox.com/s/3xxe65p21ikrhwf/subtle_white_feathers.png?dl=1');
    }

    .card-text {
        font-family: 'Apercu';
        font-size: 1.1rem;
        padding-top: 30px;
        text-align: left;
        line-height: 1.6;
    }

    .card-text-small {
        font-family: 'Apercu';
        font-size: .8rem;
        padding-top: 30px;
        text-align: left;
    }

    .step.phantom:first-of-type {
        margin-bottom: 40vh;
    }

    .step.phantom {
        height: 0;
        width: 0;
        opacity: 0;
    }

    @media screen and (max-width: 900px) {
        article {
            position: relative;
            padding: 0;
            max-width: 0rem;
            margin: 0 auto 0 auto;
        }

        .card {
            transform: translateX(-50%);
        }

        .step.phantom:first-of-type {
            margin-bottom: 75vh;
        }
    }

    @media screen and (min-width: 900px) {
        .card {
            width: 30rem;
            border-radius: unset;
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
            border: unset;
            border-left: 3px solid var(--highlightBlue);
        }

        .step.phantom:first-of-type {
            margin-bottom: 80vh;
        }
    }

    .step:last-of-type {
        margin-bottom: 0;
    }

    .step p {
        margin: 0 !important;
    }

    .footer-section {
        background-color: var(--dominantAverage);
        color: #f9f9f9;
    }
    

</style>